import React, { useState } from "react";
import "./style.css";
import img from "../../Assets/contact.jpg";
import MapView from "../../Components/MapView";
import axios from "axios";
import CustomDropdown from "../../Components/CustomDropdown";
import DynamicSeoPage from "../DynamicSeoPage";
import { useNavigate } from "react-router-dom";
import { allCountryCodes } from "../../utilities/countryCodes";
import ReCAPTCHA from "react-google-recaptcha";

const Contact = () => {
  const navigate = useNavigate();
  const [formLoading, setFormLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    countryCode: "+971",
    message: "",
  });

  const [phoneError, setPhoneError] = useState(null);

  const [captchaToken, setCaptchaToken] = useState(null);

  const handleCaptcha = (value) => {
    setCaptchaToken(value);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (e.target.name === "phone") {
      validatePhone(e.target.value);
    }
  };

  const validatePhone = (phone, customLength = null) => {
    const selectedCountry = allCountryCodes.find(
      (country) => country.dialCode === formData.countryCode
    );
    const validLength = customLength || selectedCountry.length;
    if (phone.replace(/\D/g, "").length !== validLength) {
      setPhoneError(`Phone number must be ${validLength} digits.`);
    } else {
      setPhoneError(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaToken) {
      alert("Please verify that you're not a robot.");
      return;
    }

    if (phoneError) {
      alert("Please fix the phone number error before submitting.");
      return;
    }

    try {
      setFormLoading(true);
      const response = await axios.post(
        "https://365luxuryhomes.com/api/contact",
        {
          ...formData,
          phone: `${formData.countryCode}${formData.phone}`,
          token: captchaToken,
        }
      );

      if (response.status === 200) {
        alert("Your message has been sent successfully!");
        navigate("/thank-you");
        setFormData({
          name: "",
          email: "",
          phone: "",
          countryCode: "+880",
          message: "",
        });
      } else {
        alert("Something went wrong. Please try again later.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Error submitting form. Please try again later.");
    } finally {
      setFormLoading(false);
    }
  };

  return (
    <>
      <DynamicSeoPage
        page="contact-us"
        defalut={"Contact Us - 365 Luxury Homes"}
      />
      <h1 className="sr-only">
        Contact 365 Luxury Homes - Get in Touch With Us
      </h1>
      <section className="pb-10 bg-[#fdfcf5]">
        <div
          className="conact-banner w-full lg:h-96 md:h-72 h-56"
          style={{
            backgroundImage: `url(${img})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>
        <div className="-mt-20">
          <div className="container">
            <div className=" flex flex-col items-center justify-center text-[#74716d]">
              <div className="w-full text-center px-4">
                <div className="bg-white pb-10 p-4">
                  <div className="mb-8 pt-8">
                    <h2 className="text-4xl font-semibold">SAY HELLO</h2>
                    <p className="text-sm mt-2">DROP US A LINE</p>
                  </div>
                  <form
                    onSubmit={handleSubmit}
                    className="space-y-6 max-w-xl mx-auto"
                  >
                    <div>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        placeholder="Name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="w-full border-b border-[#aca9a5] bg-transparent focus:outline-none focus:ring-0 text-sm placeholder-[#aca9a5] text-[#74716d] h-[50px]"
                      />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                          placeholder="Email"
                          className="w-full border-b border-[#aca9a5] bg-transparent focus:outline-none focus:ring-0 text-sm placeholder-[#aca9a5] text-[#74716d] h-[50px]"
                        />
                      </div>
                      <div className="flex flex-col gap-2">
                        <div className="flex">
                          <CustomDropdown
                            allCountryCodes={allCountryCodes}
                            formData={formData}
                            fieldHeight="50px"
                            setFormData={setFormData}
                          />
                          <input
                            type="text"
                            id="phone"
                            name="phone"
                            placeholder="Phone"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                            className="w-2/3 border-b border-[#aca9a5] bg-transparent focus:outline-none focus:ring-0 text-sm placeholder-[#aca9a5] text-[#74716d] h-[50px]"
                          />
                        </div>
                        {phoneError && (
                          <p className="text-red-500 text-xs mt-1">
                            {phoneError}
                          </p>
                        )}
                      </div>
                    </div>
                    <div>
                      <textarea
                        id="message"
                        name="message"
                        placeholder="Message"
                        value={formData.message}
                        onChange={handleChange}
                        rows="4"
                        className="w-full border-b border-[#aca9a5] bg-transparent focus:outline-none focus:ring-0 text-sm placeholder-[#aca9a5] text-[#74716d] resize-none"
                      ></textarea>
                    </div>
                    <ReCAPTCHA
                      sitekey="6LfeklorAAAAAPUFX08mcywgvxkSSOv-dczoUTrv"
                      onChange={handleCaptcha}
                    />
                    <button
                      type="submit"
                      className="bg-[#aca9a5] text-white px-6 hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-400 inline-flex items-center justify-center h-[50px] rounded-md"
                    >
                      {formLoading ? "Sending..." : "Submit"}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="pb-14">
        <div className="container">
          <div className="grid lg:grid-cols-3 md:grid-cols-1 gap-6 mt-24 text-xs">
            {/* Email */}
            <div className="flex text-[#74716d] gap-2 flex-col items-center space-x-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width={32}
                height={32}
                className="text-inherit"
                fill={"none"}
              >
                <path
                  d="M2 6L8.91302 9.91697C11.4616 11.361 12.5384 11.361 15.087 9.91697L22 6"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                />
                <path
                  d="M2.01577 13.4756C2.08114 16.5412 2.11383 18.0739 3.24496 19.2094C4.37608 20.3448 5.95033 20.3843 9.09883 20.4634C11.0393 20.5122 12.9607 20.5122 14.9012 20.4634C18.0497 20.3843 19.6239 20.3448 20.7551 19.2094C21.8862 18.0739 21.9189 16.5412 21.9842 13.4756C22.0053 12.4899 22.0053 11.5101 21.9842 10.5244C21.9189 7.45886 21.8862 5.92609 20.7551 4.79066C19.6239 3.65523 18.0497 3.61568 14.9012 3.53657C12.9607 3.48781 11.0393 3.48781 9.09882 3.53656C5.95033 3.61566 4.37608 3.65521 3.24495 4.79065C2.11382 5.92608 2.08114 7.45885 2.01576 10.5244C1.99474 11.5101 1.99475 12.4899 2.01577 13.4756Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                />
              </svg>
              <p className="leading-[24px] text-[16px] text-center">
                info@365luxuryhomes.com
              </p>
            </div>

            {/* Address */}
            <div className="flex text-[#74716d] gap-2 flex-col items-center space-x-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width={32}
                height={32}
                className="text-inherit"
                fill={"none"}
              >
                <path
                  d="M13.6177 21.367C13.1841 21.773 12.6044 22 12.0011 22C11.3978 22 10.8182 21.773 10.3845 21.367C6.41302 17.626 1.09076 13.4469 3.68627 7.37966C5.08963 4.09916 8.45834 2 12.0011 2C15.5439 2 18.9126 4.09916 20.316 7.37966C22.9082 13.4393 17.599 17.6389 13.6177 21.367Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                />
                <path
                  d="M15.5 11C15.5 12.933 13.933 14.5 12 14.5C10.067 14.5 8.5 12.933 8.5 11C8.5 9.067 10.067 7.5 12 7.5C13.933 7.5 15.5 9.067 15.5 11Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                />
              </svg>
              <p className="leading-[24px] text-[16px] text-center">
                Bluewaters Island, Dubai
              </p>
            </div>

            {/* Phone */}
            <div className="flex text-[#74716d] gap-2 flex-col items-center space-x-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width={32}
                height={32}
                className="text-inherit"
                fill={"none"}
              >
                <path
                  d="M5 9C5 5.70017 5 4.05025 6.02513 3.02513C7.05025 2 8.70017 2 12 2C15.2998 2 16.9497 2 17.9749 3.02513C19 4.05025 19 5.70017 19 9V15C19 18.2998 19 19.9497 17.9749 20.9749C16.9497 22 15.2998 22 12 22C8.70017 22 7.05025 22 6.02513 20.9749C5 19.9497 5 18.2998 5 15V9Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <path
                  d="M11 19H13"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9 2L9.089 2.53402C9.28188 3.69129 9.37832 4.26993 9.77519 4.62204C10.1892 4.98934 10.7761 5 12 5C13.2239 5 13.8108 4.98934 14.2248 4.62204C14.6217 4.26993 14.7181 3.69129 14.911 2.53402L15 2"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                />
              </svg>
              <p className="leading-[24px] text-[16px] text-center">
                +971 52 143 4186
              </p>
            </div>
          </div>
          <div className="mt-12 rounded-xl overflow-hidden">
            <MapView />
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
